module.exports = __webpack_public_path__ + "static/media/Freelance.b010d025.svg";